/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, IconGroup } from 'semantic-ui-react'
import { Option } from '../Option'
import React, { useEffect, useState } from 'react'
import DefinePickupTime from '../../DefinePickupTime'
import { UltyModalWrapperContext } from '../../../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { delayPickupTime } from '../../../../../../services/Order/Order.service'
import { useParams } from 'react-router-dom-v5-compat'
import { useTranslation } from 'react-i18next'
import { isPast } from 'date-fns'
import { TIME } from '../../../../../../services/date.service'
import { ultyToast } from '../../../../../Shared/UltyToast/UltyToast'

const AddReadyTime = ({pickupAt}) => {
    const [t] = useTranslation()
    const params = useParams()
    const id = +params.id
    const {handleUltyModalWrapper} = React.useContext(UltyModalWrapperContext)
    const queryClient = useQueryClient()
    const [enabledState, setEnabledState] = useState({
        isAlreadyAdjusted: false,
        isPickupAtPassed: isPast(new Date(pickupAt)),
    })

    useEffect(() => {
        const interval = setInterval(() => {
            if (isPast(new Date(pickupAt))) {
                setEnabledState(prev => ({
                    ...prev,
                    isPickupAtPassed: true,
                }))
            }
        }, TIME.MINUTE_IN_MS)

        return () => clearTimeout(interval)

    }, [pickupAt])

    const delayPickupTimeMutation = useMutation({
        mutationFn: ({delayPickupTimeMinutes}) => delayPickupTime(id, delayPickupTimeMinutes),
        onSuccess: (data) => {
            ultyToast({ type: 'success', title: t('order.pickup_at_date', {pickupAt: new Date(data.pickupAt).toLocaleString()}) })
        },
        onError: (error) => {
            if (error.message === 'ALREADY_ADJUSTED') {
                ultyToast({ type: 'error', title: t('order.already_adjusted') })
            } else if (error.message === 'PICKUP_TIME_PASSED') {
                ultyToast({ type: 'error', title: t('order.pickup_time_passed ') })
            } else {
                ultyToast({ type: 'error', title: t('global.anErrorOccurred') })
            }

            setEnabledState(prev => ({
                ...prev,
                isAlreadyAdjusted: true,
            }))
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({queryKey: ['orders', id]})
        },
    })

    const defineDelayPickupTime = () => {
        const modalSettings = {
            size: 'tiny',
            component: <DefinePickupTime
              onSubmit={(delayPickupTimeMinutes) => delayPickupTimeMutation.mutate({delayPickupTimeMinutes})}
            />,
        }

        handleUltyModalWrapper(true, modalSettings)
    }

    const isEnabled = !enabledState.isAlreadyAdjusted && !enabledState.isPickupAtPassed

    return (
      <Option
        onClick={isEnabled ? defineDelayPickupTime : undefined}
        css={css`
            opacity: ${isEnabled ? 1 : .5};
        `}
      >
          <IconGroup>
              {delayPickupTimeMutation.isPending ? <Icon loading name={'circle notched'}/> :
                <>
                    <Icon name="stopwatch" color={isEnabled ? 'teal' : 'grey'}/>
                    {isEnabled && <Icon corner name="add" color="grey"/>}
                    {!isEnabled && <Icon corner name="checkmark" color="teal"/>}
                </>
              }
          </IconGroup>
          {
              isEnabled ?
                <p>{t('order.add_ready_time_delay')}</p> :
                enabledState.isPickupAtPassed ?
                  <p>{t('order.add_ready_time_pickup_time_passed')}</p> :
                  enabledState.isAlreadyAdjusted ?
                    <p>{t('order.add_ready_time_delay_already_done')}</p> :
                    <p>{t('order.add_ready_time_delay_already_done')}</p>
          }
      </Option>
    )
}

export { AddReadyTime }
